import React from 'react';
import { keyBy } from 'lodash';
import { Toolbar, NoData, ColumnMenu } from 'components/DataGrid';
import { WrapDataGridTable } from './Style'
import { dataGrid, dataGridModel } from 'keys';
import { useSelector, useDispatch } from 'react-redux';
import { actions } from 'store';
import PermissionHOC from 'components/Permissions/PermissionHOC';
import './print.css'

// TABLEאלא ב DATA GRIDאנחנו לא משתמשים ב 
const CustomDataGrid = (props) => {
    const { hideToolbar, CustomFooter, hideSerialCol, sortModel, customToolBar, hidePagination, hideQuickFilter, fields, rowId = "id", loading, visibilityModelKey, ColumnMenuItem, data, onRowSelectionModelChange, checkboxSelection } = props
    const { visibilityModel } = useSelector(state => state.dataGrid)
    const dispatch = useDispatch()

    const onSortModelChange = (newSortModel) => {
        if (newSortModel.length) {
            const { field } = newSortModel?.[0]
            const mappingFields = keyBy(fields, "field")
            mappingFields[field].sort?.(newSortModel?.[0])
        }
    }

    const serialCol = {
        width: 50, field: "index", headerName: "#", filterable: false, headerAlign: 'center', align: 'center',
        renderCell: (params) => params.api.getAllRowIds().indexOf(params.row[rowId]) + 1
    }

    const sortComparator = (v1, v2, param1, param2) => {
        if (v1 === v2) {
            return param1.row.lastName.localeCompare(param2.row.lastName);
        }
        return v1.localeCompare(v2);
    };

    return (
        <WrapDataGridTable
            permissionHOC="gridColumn"
            loading={!data}
            rows={data || []}
            columns={hideSerialCol ? fields : [serialCol, ...fields]}
            disableSelectionOnClick
            disableRowSelectionOnClick
            localeText={dataGrid}
            getRowId={(row) => row[rowId]}
            hidePagination={hidePagination}
            checkboxSelection={checkboxSelection}
            onRowSelectionModelChange={onRowSelectionModelChange}
            columnVisibilityModel={visibilityModel?.[visibilityModelKey] || {}}
            onColumnVisibilityModelChange={(newModel) => {
                dispatch(actions.setVisibilityModel({ key: dataGridModel[visibilityModelKey], value: newModel }))
            }}
            slots={{
                columnMenu: ColumnMenu,
                toolbar: !hideToolbar && Toolbar,
                noRowsOverlay: NoData,
                footer: CustomFooter
            }}
            slotProps={{
                toolbar: {
                    showQuickFilter: !hideQuickFilter,
                    customToolBar: customToolBar
                },
                pagination: {
                    hidden: hidePagination,
                    labelRowsPerPage: "מספר השורות לעמוד"
                },
            }}
            onSortModelChange={onSortModelChange}
        />
    );
}


export default PermissionHOC(CustomDataGrid)
